import React, {useEffect, useState} from "react";
import { useParams, Link } from 'react-router-dom';
import Navigation from "../partials/Navigation";
import { getWithExpiry } from '../common';
import CourseProgress from "../partials/CourseProgress";
import { useTranslation } from "react-i18next";
import {Helmet} from "react-helmet";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import BoardInstructions from "../partials/BoardInstructions";
import { StickyContainer, Sticky } from 'react-sticky';
import BoardNav from "../partials/Boards/BoardNav";

const Lesson = () => {

	const { lesson, board_id } = useParams();
    const [ courseImage, setCourseImage] = useState('');
	const [ lessonTitle, setLessonTitle] = useState('');
    const [ lessonContent, setLessonContent] = useState('');
    const [ topics, setTopics] = useState([]);
	const [translation] = useTranslation("translations");

    //const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

	useEffect(() => {

		const courseData = getWithExpiry(`sy_board_${board_id}_guides`);

		if ( ! courseData ) return;

		const lessonData = Object.keys(courseData).filter(l => courseData[l].name === lesson).map(l => courseData[l]);

		if ( ! lessonData[0] ) return;

		setCourseImage( lessonData[0].course_image );
		setLessonTitle( lessonData[0].title );
        setLessonContent( lessonData[0].content );
        setTopics( lessonData[0].topics );

		//console.log( lessonData );

	}, [lesson, board_id]);

	return (
		<div className="main-wrapper">
			<Helmet>
				<title>{lessonTitle}</title>
				<meta name="description" content="" />
			</Helmet>

			<Navigation />

			<div className="page-content-wrap">
				<HorizontalNav />

				<div className="pt-5 pt-lg-0 page-content-inner">

					<BoardNav />
					
					{courseImage &&
							<div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px', top: '40px'}}>
								<img src={courseImage} alt={lesson} className="w-100" style={{objectFit: 'cover'}} />
								<div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column">
									<div className="flex-grow-1 d-flex align-items-center">
										{/* <h1 className="text-white text-center">{lessonTitle}</h1> */}
									</div>
									<span className="text-white p-3 d-flex w-100 dark-overlay">
										<span className="text-white pe-3"><i className="fa fa-long-arrow-left" aria-hidden="true"></i></span>
										<Link to={`/board/${board_id}`} className="text-white">{translation("back_to_board")}</Link>
									</span>
								</div>
								{topics[0] &&
									<CourseProgress topic={topics[0].ID} />
								}
								{ ! topics[0] &&
									<CourseProgress />
								}
							</div>
						}
						
						<StickyContainer>
							<div className="mx-auto mt-4 mx-3" style={{ maxWidth: "1400px" }}>
								<div className="row justify-content-center">
									<div className="col-12 pt-5 px-4">
										<div className="row">
											<div className="col-12 col-lg-3">
												<Sticky disableCompensation>{({ style, isSticky }) => <div style={style} className={`${isSticky ? 'instructions-is-sticky' : ''}`}><BoardInstructions /></div>}</Sticky>
											</div>
											<div className="col-12 col-lg-9">
												<div className="row">
													<div className="col-12 px-3 px-lg-5">
														<div className="text-lg" dangerouslySetInnerHTML={{__html: lessonContent}}></div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</StickyContainer>
				</div>
			</div>

		</div>
	);
};

export default Lesson;
